import styled, { theme } from 'academy-common-lib/utils/Styling';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useState } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import { PublicCatalogFilters } from '../publicCatalogConstants';
import UIExpandableSection from 'UIComponents/accordion/UIExpandableSection';
import PublicCatalogAppliedFilters from './PublicCatalogAppliedFilters';
import UIBox from 'UIComponents/layout/UIBox';
import usageTracker from '../../../utils/usageTracker';
import { useClearAllFilters } from '../publicCatalogFiltersHooks';
import I18n from 'I18n';
import PublicCatalogFilterOption from './PublicCatalogMobileFilterOption';
import PublicCatalogMobileResultsDisplay from './PublicCatalogMobileResultsDisplay';
import { useGetCatalogResultsFromUrlFilters } from '../publicCatalogResultsHooks';
import { PAGE_SIZE } from './PublicCatalogResults';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MobileFiltersBar = styled.div.withConfig({
  displayName: "PublicCatalogMobileFilters__MobileFiltersBar",
  componentId: "sc-9scopd-0"
})(["background-color:", ";font-weight:500;"], theme.colors.GYPSUM);
const FiltersMenu = styled.div.withConfig({
  displayName: "PublicCatalogMobileFilters__FiltersMenu",
  componentId: "sc-9scopd-1"
})(["overflow:auto;background-color:", ";height:100vh;width:100vw;position:fixed;top:0;left:0;transition:transform 0.3s ease;transform:translateY(100vh);z-index:99;&.open{transform:translateY(0);}"], theme.colors.OLAF);
const OpenFilterMenuButton = styled(UIButton).withConfig({
  displayName: "PublicCatalogMobileFilters__OpenFilterMenuButton",
  componentId: "sc-9scopd-2"
})(["color:", " !important;font-weight:500;"], theme.colors.EERIE);
const FiltersMenuHeader = styled.header.withConfig({
  displayName: "PublicCatalogMobileFilters__FiltersMenuHeader",
  componentId: "sc-9scopd-3"
})(["background-color:", ";color:", ";font-weight:500;"], theme.colors.OBSIDIAN, theme.colors.OLAF);
const FiltersMenuResults = styled.div.withConfig({
  displayName: "PublicCatalogMobileFilters__FiltersMenuResults",
  componentId: "sc-9scopd-4"
})(["background-color:", ";color:", ";min-height:40px;"], theme.colors.PANTERA, theme.colors.OLAF);
const FilterByHeading = styled.div.withConfig({
  displayName: "PublicCatalogMobileFilters__FilterByHeading",
  componentId: "sc-9scopd-5"
})(["background-color:", ";font-weight:500;border-bottom:1px solid ", ";"], theme.colors.GYPSUM, theme.colors.GREAT_WHITE);
const StickyHeaderWrapper = styled.div.withConfig({
  displayName: "PublicCatalogMobileFilters__StickyHeaderWrapper",
  componentId: "sc-9scopd-6"
})(["position:sticky;top:0;z-index:1;"]);
const PublicCatalogMobileFilters = () => {
  var _publicCatalogData$to;
  const {
    publicCatalogData
  } = useGetCatalogResultsFromUrlFilters({
    pageSize: PAGE_SIZE
  });
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const clearAllFilters = useClearAllFilters();
  const resultsCount = (_publicCatalogData$to = publicCatalogData === null || publicCatalogData === void 0 ? void 0 : publicCatalogData.total) !== null && _publicCatalogData$to !== void 0 ? _publicCatalogData$to : null;
  const handleCloseMenuClick = () => {
    setIsMenuOpen(false);
    usageTracker.track('interaction', {
      action: 'close-mobile-catalog-filters-menu'
    });
  };
  const handleApplyButtonClick = () => {
    usageTracker.track('interaction', {
      action: 'apply-mobile-catalog-filters'
    });
    setIsMenuOpen(false);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MobileFiltersBar, {
      className: "p-x-4 p-y-2 m-bottom-2",
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        justify: "between",
        children: [/*#__PURE__*/_jsx(UIBox, {
          shrink: 1,
          style: {
            fontWeight: 400
          },
          children: /*#__PURE__*/_jsx(PublicCatalogMobileResultsDisplay, {})
        }), /*#__PURE__*/_jsx(UIBox, {
          shrink: 0,
          children: /*#__PURE__*/_jsxs(OpenFilterMenuButton, {
            className: "p-x-3 p-y-2",
            onClick: () => setIsMenuOpen(true),
            use: "unstyled",
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.catalogPage.filters.filtersMenuButton"
            }), /*#__PURE__*/_jsx(UIIcon, {
              className: "m-left-2",
              name: "filter",
              size: 22
            })]
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(FiltersMenu, {
      "aria-hidden": !isMenuOpen,
      "aria-modal": "true",
      className: isMenuOpen ? 'open' : '',
      "data-test-id": "mobile-filters-menu",
      role: "dialog",
      children: [/*#__PURE__*/_jsxs(StickyHeaderWrapper, {
        children: [/*#__PURE__*/_jsx(FiltersMenuHeader, {
          className: "p-x-5 p-y-2",
          children: /*#__PURE__*/_jsxs(UIFlex, {
            align: "center",
            justify: "between",
            children: [/*#__PURE__*/_jsx(UIButton, {
              "aria-label": I18n.text('academyPublic.catalogPage.filters.closeMobileMenuButton'),
              className: "p-left-0 p-right-4 p-y-2",
              onClick: handleCloseMenuClick,
              use: "unstyled",
              children: /*#__PURE__*/_jsx(UIIcon, {
                name: "remove",
                size: 18
              })
            }), /*#__PURE__*/_jsxs(UIFlex, {
              align: "center",
              gap: 12,
              justify: "end",
              children: [/*#__PURE__*/_jsx(UIButton, {
                className: "p-x-3 p-y-2",
                onClick: clearAllFilters,
                responsive: false,
                use: "unstyled",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyPublic.catalogPage.filters.clearAllButton"
                })
              }), /*#__PURE__*/_jsx(UIButton, {
                onClick: handleApplyButtonClick,
                responsive: false,
                use: "primary-white",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyPublic.catalogPage.filters.applyButton"
                })
              })]
            })]
          })
        }), /*#__PURE__*/_jsxs(FiltersMenuResults, {
          className: "p-x-5 p-y-2",
          "data-test-id": "mobile-filters-results",
          children: [resultsCount === 0 && /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.catalogPage.filters.noResults"
          }), resultsCount !== null && resultsCount > 0 && /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.catalogPage.filters.simpleResultsDisplay",
            options: {
              count: resultsCount
            }
          })]
        }), /*#__PURE__*/_jsx(FilterByHeading, {
          className: "p-x-5 p-y-2",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.catalogPage.filters.filterBy"
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        children: Object.entries(PublicCatalogFilters).map(([filterName, filterOptions]) => {
          return /*#__PURE__*/_jsx(UIExpandableSection, {
            titleText: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `academyPublic.catalogPage.filters.${filterName}.displayText`
            }),
            children: filterOptions.map(option => /*#__PURE__*/_jsx(PublicCatalogFilterOption, {
              filterName: filterName,
              option: option
            }, option))
          }, filterName);
        })
      })]
    }), /*#__PURE__*/_jsx(PublicCatalogAppliedFilters, {})]
  });
};
export default PublicCatalogMobileFilters;